// extracted by mini-css-extract-plugin
export default {"wrapper":"TextmarkPicker_wrapper__P7wFy","secondaryItemLabel":"TextmarkPicker_secondaryItemLabel__301h8","treeWrapper":"TextmarkPicker_treeWrapper__70oEB"};